import { render, staticRenderFns } from "./workFlowDefine.vue?vue&type=template&id=490b4fa0&scoped=true&"
import script from "./workFlowDefine.vue?vue&type=script&lang=js&"
export * from "./workFlowDefine.vue?vue&type=script&lang=js&"
import style0 from "./workFlowDefine.vue?vue&type=style&index=0&id=490b4fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b4fa0",
  null
  
)

export default component.exports